function guideDismissedKey(userId: string): string {
  return `hibro.workbench.guideDismissed:${userId}`
}

export function isGuideDismissed(userId: string): boolean {
  try {
    return localStorage.getItem(guideDismissedKey(userId)) === '1'
  } catch {
    return false
  }
}

export function dismissGuide(userId: string): void {
  try {
    localStorage.setItem(guideDismissedKey(userId), '1')
  } catch {
    /* ignore */
  }
}
